<h3 mat-dialog-title>{{ title }}</h3>
<mat-dialog-content class="mat-typography">
    <form class="example-form">
 

  

    <mat-form-field class="example-full-width">
        <input matInput placeholder="Exposant" aria-label="Exposant" [matAutocomplete]="auto" [formControl]="control">
        <mat-autocomplete #auto="matAutocomplete"  [displayWith]="displayFn" >
            <mat-option *ngFor="let exhibitor of exhibitors | async" [value]="exhibitor"  (onSelectionChange)='select(exhibitor)'>
                {{exhibitor.prospectId.raisonSocial}}
            </mat-option>
        </mat-autocomplete>
      </mat-form-field>

</form>

</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-raised-button mat-dialog-close>No</button>&nbsp;
    <button class="btn-info" mat-raised-button [mat-dialog-close]="exhibitor" cdkFocusInitial>Yes</button>
</mat-dialog-actions>
